// Tiny inline badge: WI = Walk-in (blue), OL = Online (purple, covers phone + attender)
// Used in Doctor and Staff dashboards next to patient names.
export const SourceBadge = ({ patient, className = '' }) => {
  const src = patient?.arrival_source || 'walk_in';
  const isWalk = src === 'walk_in';
  const palette = isWalk
    ? 'bg-blue-100 text-blue-800 border-blue-300'
    : 'bg-purple-100 text-purple-800 border-purple-300';
  return (
    <span
      data-testid={`source-badge-${patient?.id || 'x'}`}
      data-source={src}
      className={`inline-flex items-center gap-0.5 px-1 py-0 rounded-md text-[9px] font-bold uppercase tracking-wider border ${palette} ${className}`}
      title={isWalk ? 'Walk-in' : (src === 'attender' ? 'Booked via attender' : 'Booked by phone')}
    >
      {isWalk ? 'WI' : 'OL'}
    </span>
  );
};
